'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiText = require('@spp/ui-text');

var _uiText2 = _interopRequireDefault(_uiText);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Blockquote = function Blockquote(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        stylizr = _ref.stylizr;
    return _react2.default.createElement(
        'blockquote',
        { className: theme.root },
        _react2.default.createElement(_uiText2.default, {
            text: text,
            theme: theme,
            stylizr: stylizr
        })
    );
};

Blockquote.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        innerText: _propTypes2.default.shape({
            text: _propTypes2.default.string
        })
    })
};

Blockquote.defaultProps = {
    theme: {},
    stylizr: function stylizr(text) {
        return text;
    }
};

exports.default = Blockquote;
//# sourceMappingURL=Blockquote.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-blockquote/lib/cjs/Blockquote.js
 ** module id = 501
 ** module chunks = 1
 **/